import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { useGetInstitutionSettingsQuery } from '@/services/institutionApi';
import { setBranding, resetBranding } from '@/store/slices/brandingSlice';

/**
 * BrandingInitializer component that fetches branding settings from API
 * and dispatches them to Redux store when user is authenticated
 */
export function BrandingInitializer() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  // Always fetch if authenticated to ensure we have the latest branding
  const { data: institutionSettings, isError } = useGetInstitutionSettingsQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (institutionSettings) {
      const branding = institutionSettings.brandingSettings;
      
      // Only set branding if we have at least primary or secondary color
      if (branding?.primaryColor || branding?.secondaryColor) {
        dispatch(
          setBranding({
            primaryColor: branding.primaryColor || '#631760',
            secondaryColor: branding.secondaryColor || '#AD14A7',
            logoUrl: branding.logoUrl || undefined,
            faviconUrl: branding.faviconUrl || undefined,
          })
        );
      } else {
        // If the new account has no custom branding, we must purge any lingering local storage cache!
        dispatch(resetBranding());
      }
    } else if (isError) {
      // If the backend denied access or failed, we MUST drop the previous account's overrides
      dispatch(resetBranding());
    }
  }, [institutionSettings, isError, dispatch, isAuthenticated]);

  return null;
}
